import { Component } from '@angular/core';

@Component({
  selector: 'app-project-email',
  templateUrl: './project-email.component.html'
})
export class ProjectEmailComponent {}
